import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import _ from 'lodash';
import { Loader } from 'react-feather';
import { EntityToUpdate } from './EditDrawerSuccessAndFailure';

export const EditDrawerProcessing = ({ count, entityToUpdate }: { count: number; entityToUpdate: string }) => {
  const processingText =
    entityToUpdate === EntityToUpdate.MENU
      ? t('editMenuPrice.processingMenus', { count })
      : entityToUpdate === EntityToUpdate.BUNDLE_UC_STORE_GROUPS
      ? t('bundleUpcharges.editDrawer.processingStoreGroups', { count })
      : t('bundleUpcharges.editDrawer.processingStores', { count });

  return (
    <Grid container direction="row">
      <Grid container direction="row" justifyContent="flex-start" alignItems="center">
        <Grid item>
          <Loader
            style={{
              animation: 'spin-animation 1s infinite',
              animationTimingFunction: 'linear',
              display: 'inline-block',
            }}
          />
        </Grid>
        <Grid item>
          <Typography fontSize="2.0rem" fontWeight="700" pl={1} data-testid="processingText">
            {processingText}
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="column">
        <Grid item>
          <Typography component="p" fontSize="2.0rem" pl={4}>
            {t('common.dontCloseDrawer')}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
